import { app } from '../../../../../app';
import { Controller } from './copy-shared-accounts.controller';

app.component('companyUserDirectoriesManageUserCopySharedAccounts', {
    bindings: {
        accounts: '<',
        accountsForCompanyUser: '<',
        companyId: '<',
        companyUser: '<',
    },
    controller: Controller,
    templateUrl: require('./copy-shared-accounts.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/copy-shared-accounts/copy-shared-accounts.component.js